<template>
  <div class="live-set-component">
    <div class="dialog-header">
      <h1>设置</h1>
      <img
        class="close-button"
        src="@saas/pages/assets/images/live/live-set/close-icon.png"
        @click="handleClose"
      />
    </div>
    <el-container class="settings-container can-not-drag-wrap">
      <el-aside width="200px" class="settings-aside">
        <el-menu
          :default-active="activeSetting"
          class="settings-menu"
          @select="handleMenuSelect"
        >
          <el-menu-item
            v-for="item in filteredMenuList"
            :key="item.index"
            :index="item.index"
          >
            <img
              :src="
                require('@saas/pages/assets/images/live/live-set/' +
                  (activeSetting === item.index ? item.activeIcon : item.icon) +
                  '.png')
              "
              class="menu-icon"
              alt=""
            />
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="settings-main">
        <!-- 常规设置 -->
        <general-setting v-if="activeSetting === 'general'" />
        <camera-setting v-if="activeSetting === 'video'" />
        <audio-setting v-if="activeSetting === 'audio'" />
        <!-- 工具栏位置设置 -->
        <toolbar-position-setting v-if="activeSetting === 'toolbar'" />
        <!-- 白板背景设置 -->
        <whiteboard-bg-setting v-if="activeSetting === 'whiteboard'" />
        <!-- 其他设置页面将在这里添加 -->
        <learning-setting v-if="activeSetting === 'learning'" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { USER_ROLE_NAME } from "@saas/live-sdk/src/services/utils/constants.js";
import { mapState, mapMutations } from "vuex";
import CameraSetting from "./settings-pages/CameraSetting.vue";
import AudioSetting from "./settings-pages/AudioSetting.vue";
import GeneralSetting from "./settings-pages/GeneralSetting.vue";
import ToolbarPositionSetting from "./settings-pages/ToolbarPosition.vue"; // Import the new component
import WhiteboardBgSetting from "./settings-pages/WhiteboardBg.vue"; // Import the new component
import LearningSetting from "./settings-pages/LearningSetting.vue"; // Import the new component
export default {
  name: "LiveSet",
  components: {
    ToolbarPositionSetting, // Register the component
    WhiteboardBgSetting, // Register the new component
    GeneralSetting, // Register the component
    AudioSetting,
    CameraSetting,
    LearningSetting,
  },
  props: {
    initActive: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeSetting: "general",
      menuList: [
        {
          index: "general",
          title: "常规",
          icon: "setting-icon",
          activeIcon: "setting-active-icon",
          showForTeacher: true,
          showForStudent: false,
        },
        {
          index: "video",
          title: "视频",
          icon: "video-icon",
          activeIcon: "video-active-icon",
          showForTeacher: true,
          showForStudent: true,
        },
        {
          index: "audio",
          title: "音频",
          icon: "audio-icon",
          activeIcon: "audio-active-icon",
          showForTeacher: true,
          showForStudent: true,
        },
        {
          index: "learning",
          title: "学习设置",
          icon: "learning-icon",
          activeIcon: "learning-active-icon",
          showForTeacher: true,
          showForStudent: false,
        },
        {
          index: "whiteboard",
          title: "白板背景",
          icon: "whiteboard-icon",
          activeIcon: "whiteboard-active-icon",
          showForTeacher: true,
          showForStudent: false,
        },
        {
          index: "toolbar",
          title: "工具栏位置",
          icon: "toolbar-icon",
          activeIcon: "toolbar-active-icon",
          showForTeacher: true,
          showForStudent: false,
        },
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState("live", ["liveService", "userStatus", "roomInfo"]),
    isTeacher() {
      return USER_ROLE_NAME[this.userStatus?.user_role] !== "student";
    },
    filteredMenuList() {
      let menuList = this.menuList.filter((item) =>
        this.isTeacher ? item.showForTeacher : item.showForStudent
      );
      if (this.roomInfo.mode != 1) {
        return menuList;
      }

      return menuList.filter((item) => item.index !== "video");
    },
  },
  watch: {
    isTeacher: {
      handler(newVal) {
        if (newVal) {
          this.activeSetting = "general";
        } else {
          if (this.roomInfo.mode !== 1) {
            this.activeSetting = "video";
          } else {
            this.activeSetting = "audio";
          }
        }
      },
      immediate: true,
    },
    initActive: {
      handler(val) {
        if (val) {
          this.activeSetting = val;
        } else {
          this.isTeacher ? "general" : "video";
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", ["setShowSet"]),
    // 处理菜单选中事件
    handleMenuSelect(index) {
      this.activeSetting = index;
      // 在这里可以根据选中的index加载对应的设置内容
    },
    // 处理关闭事件
    handleClose() {
      //  todo  关闭
      this.liveService.stopMicDeviceTest();
      this.setShowSet({
        visible: false,
      });
      this.$emit("close");
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
// Using SCSS variables if available, otherwise define colors directly
$dark-bg: #18181b; // Example dark background color
$dark-text: #ecedee; // Example light text color
$border-color: #27272a; // Example border color
$menu-active-bg: rgba(
  22,
  93,
  255,
  0.2
); // Example background for active menu item
$aside-width: 182px; // Adjust aside width to match desired look
$dialog-width: 658px; // Example dialog width
$dialog-height: 640px; // Example dialog height
$active-color: #165dff; // Example active color (Element UI primary blue)

.live-set-component {
  width: $dialog-width;
  height: $dialog-height;
  color: $dark-text;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: $dark-bg;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
  border: 2px solid #27272a;
}

.dialog-header {
  // padding: 10px 16px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid $border-color;
  flex-shrink: 0;
  height: 48px;
  display: flex;
  align-items: center;

  h1 {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    margin: 0 auto;
  }

  .close-button {
    position: absolute;
    right: 17px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    cursor: pointer;
    color: #71717a;
    padding: 3px;
    width: 30px;
    height: 30px;
  }
}

.settings-container {
  flex-grow: 1;
  display: flex;
  height: 100%;
  overflow: hidden;
}

.settings-aside {
  width: $aside-width !important;
  border-right: 1px solid $border-color;
  overflow-y: auto;
  flex-shrink: 0;
}

.settings-menu {
  border-right: none;
  background-color: $dark-bg;
  padding: 8px 12px;
  height: 100%;

  .el-menu-item {
    margin: 4px 0;
    color: $dark-text;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    cursor: pointer;
    padding-left: 12px !important;
    display: flex;
    align-items: center;
    i {
      margin-right: 8px;
      color: $dark-text;
    }
    span {
      font-size: 14px;
      font-weight: 500;
    }

    &.is-active {
      background-color: $menu-active-bg;
      color: $active-color;
      i {
        color: $active-color;
      }
    }
    &:hover {
      background-color: $menu-active-bg;
    }
    .menu-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
}

.settings-main {
  flex-grow: 1;
  padding: 16px 28px !important;
  overflow-y: auto;
}
</style>
